import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useTitle } from 'react-use';

import Loading from '@/components/atoms/Loading/Loading';
import { resetIdentity } from '@/segment/segment';
import { LOGOUT_ROUTE } from '@/util/constants';

/**
 * Logout page that shows loading state while redirecting to WorkOS logout
 * The redirect happens immediately, so users only briefly see this loading state
 */
const Logout = () => {
  const { t } = useTranslation();

  useTitle(t('auth.logging_out'));

  useEffect(() => {
    resetIdentity();
    window.location.href = LOGOUT_ROUTE;
  }, []);

  return <Loading label={t('auth.logging_out')} />;
};

export default Logout;
